import { render, staticRenderFns } from "./SelectCompanyDidNotPurchaseReason.vue?vue&type=template&id=b1c4ebf0&"
import script from "./SelectCompanyDidNotPurchaseReason.vue?vue&type=script&lang=ts&"
export * from "./SelectCompanyDidNotPurchaseReason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c4ebf0')) {
      api.createRecord('b1c4ebf0', component.options)
    } else {
      api.reload('b1c4ebf0', component.options)
    }
    module.hot.accept("./SelectCompanyDidNotPurchaseReason.vue?vue&type=template&id=b1c4ebf0&", function () {
      api.rerender('b1c4ebf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/SelectCompanyDidNotPurchaseReason.vue"
export default component.exports